module.exports = __webpack_public_path__ + "static/media/ami_pt.f8e45f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/ami_pt.png
// module id = 571
// module chunks = 1